import { twJoin } from 'tailwind-merge';

type Props = {
  className?: string;
};

export const AllocabXStripe = ({ className }: Props) => {
  return (
    <div className={twJoin('relative inline-flex items-center justify-center overflow-hidden rounded-lg', className)}>
      <img src="assets/images/t2p.png" alt="Tap to pay" className="w-96 blur-sm" />
      <img src="assets/images/allocab-x-stripe.png" alt="Allocab x Stripe" className="w-9/12 absolute" />
    </div>
  );
};
